module.exports = __webpack_public_path__ + "static/media/car_insurance.532c6d26.svg";